<template>
    <div>
        <b-card class="mx-1 mx-sm-5 custom-border">
            <div class="my-2">
                <b-row>
                    <b-col cols="0" sm="1"></b-col>
                    <b-col>
                    <h5> <b>Customer details</b></h5>
                    <b-row>
                        <b-col class="pr-0 header" cols="4" sm="2">โครงการ</b-col>
                        <b-col cols="8" sm="10">{{show.project}}</b-col>
                        <b-col class="pr-0 header" cols="4" sm="2">บ้านเลขที่</b-col>
                        <b-col cols="8" sm="10">{{show.unitNumber}}</b-col>
                        <b-col class="pr-0 header" cols="4" sm="2">อีเมลล์</b-col>
                        <b-col cols="8" sm="10">{{show.email}}</b-col>
                        <b-col class="pr-0 header" cols="4" sm="2">เบอร์มือถือ</b-col>
                        <b-col cols="8" sm="10">{{show.mobile}}</b-col>
                    </b-row>
                    <h5 class="mt-3"> <b>Category</b></h5>
                    <b-row>
                        <b-col cols="12"> {{show.requestName}} </b-col>
                    </b-row>
                    <h5 class="mt-3"> <b>Description</b></h5>
                    <b-row>
                        <b-col cols="12"><span v-html="show.description">></span></b-col>
                    </b-row>
                    <hr/>
                    <lightbox :images="images"></lightbox>
                    <hr/>
                    <h5 class="mt-3"> <b>Status</b></h5>
                    <div v-if="'new' === show.status">
                      <font class="font-pending"><i class="fa fa-circle" aria-hidden="true"></i></font> new
                    </div>
                    <div v-else>
                      <font class="font-closed"><i class="fa fa-circle" aria-hidden="true"></i></font> {{show.status}}
                    </div>
                    </b-col>
                    <b-col cols="0" sm="1"></b-col>
                </b-row>
            </div>
        </b-card>
        <footer>
            <p class="copyright">© 2020 DTGO Corporation Limited, All Right Reserved.</p>
        </footer>
    </div>
</template>

<script>
import axios from 'axios';
import { ProjectList } from '../../../models/project-list';
// import { convertBuddhistTime } from '../../../assets/utils/time';

export default {
  data () {
    return {
      projectList: new ProjectList(),
      show: {},
      images: []
    };
  },
  methods: {
    getData () {
      const token = this.$route.params.id;
      const headers = { Accept: 'application/json' };
      axios.get(process.env.VUE_APP_URL_MQDCONE_API + `/mqdc-one/service-requests-management/public?token=${token}`, { headers: headers })
        .then(response => {
          const data = response.data.data;
          if (data) {
            this.show.project = this.projectList.getProjectNameByCode(data.projectCode);
            this.show.unitNumber = data.unitNumber;
            this.show.email = data.user.email;
            this.show.mobile = data.user.mobileLocal ? [data.user.mobileLocal.slice(0, 3), '-', data.user.mobileLocal.slice(3)].join('') : '';
            this.show.requestName = data.careService.name;
            this.show.description = data.description.replace(/(\r)*\n/g, '<br>');
            // for (let i = 0; i <= data.appointmentDates.length; i++) {
            //   console.log(data.appointmentDates[i].date);
            //   this.show[`date${i + 1}`] = convertBuddhistTime(new Date(data.appointmentDates[i].date));
            //   this.show[`timePeriod${i + 1}`] = 'allDay' === data.appointmentDates[i].timePeriod ? 'All Day' : data.appointmentDates[i].timePeriod;
            // }
            // this.show.date1 = convertBuddhistTime(new Date(data.appointmentDates[0].date));
            // this.show.timePeriod1 = 'allDay' === data.appointmentDates[0].timePeriod ? 'All Day' : data.appointmentDates[0].timePeriod;
            // this.show.date2 = convertBuddhistTime(new Date(data.appointmentDates[1].date));
            // this.show.timePeriod2 = 'allDay' === data.appointmentDates[1].timePeriod ? 'All Day' : data.appointmentDates[1].timePeriod;
            // this.show.date3 = convertBuddhistTime(new Date(data.appointmentDates[2].date));
            // this.show.timePeriod3 = 'allDay' === data.appointmentDates[2].timePeriod ? 'All Day' : data.appointmentDates[2].timePeriod;
            this.images = [];

            data.files.forEach(file => {
              this.images.push({
                src: file.file.original
              });
            });
            this.show.status = data.status;
          }
        })
        .catch(error => {
          this.errorMessage = error.response ? error.response.data : error.message;
        })
        .finally(() => {
          this.isBusy = false;
        });
    }
  },
  mounted () {
    this.getData();
  }
};
</script>

<style>
    html,body{
        background-color: #339DAA;
        height: 100%;
    }
   .vue-lightbox > ul > li{
      cursor: pointer;
    }
    img {
        image-orientation: from-image;
    }
</style>

<style scoped>
    footer {
        position: relative;
        width: 100%;
        height: 40px;
    }

    p.copyright {
        position: absolute;
        width: 100%;
        color: #fff;
        font-size: 1.0em;
        text-align: center;
        bottom:0;
    }
    .vue-lightbox{
        width: 100%;
    }
    .font-pending{
        color: #339DAA;
    }
    .font-closed{
        color:#4dbd74;
    }
    .custom-border{
    padding: 5px;
    border-radius: 0px 0px 20px 20px;
    }
    .header{
        color: #999999;
    }
</style>
